import { useTranslation } from 'react-i18next'

import {
  useGetJobLevelsQuery,
  useGetSurveyWindowArchiveComparisonQuery,
} from 'store/surveyWindow/surveyWindowApi'

import { IReportsSidebarMenuGroup } from '../types/reportSidebarMenuGroup'

export const useMenuGroupDiversity = (): {
  sidebarItems: IReportsSidebarMenuGroup | undefined
} => {
  const { t } = useTranslation()

  const { data: archive, isSuccess: isArchiveSuccess } =
    useGetSurveyWindowArchiveComparisonQuery()

  const latestArchiveSurveyWindow = archive?.[0]

  const { data: jobLevelsCount } = useGetJobLevelsQuery(
    {
      surveyWindowId: latestArchiveSurveyWindow?.id ?? 0,
    },
    { skip: !latestArchiveSurveyWindow }
  )

  const DIVERSITY_CODE = 'diversity'
  if (isArchiveSuccess) {
    return {
      sidebarItems: {
        code: DIVERSITY_CODE,
        enabled: !!latestArchiveSurveyWindow,
        text: t(`${DIVERSITY_CODE}.title`),
        url: `/${DIVERSITY_CODE}`,
        items:
          jobLevelsCount && jobLevelsCount?.length > 0
            ? jobLevelsCount.map(({ level, completed }) => ({
                code: level ?? '',
                text: t(`jobLevel.${level.toLowerCase()}`),
                url: `/${DIVERSITY_CODE}/${level}`,
                enabled: completed != 0,
              }))
            : undefined,
      },
    }
  }
  return { sidebarItems: undefined }
}
